import React, { useState } from 'react';
import { Button } from './ui/Button';
import { User, Lock, ArrowRight } from 'lucide-react';
export function LoginForm() {
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate login
    setTimeout(() => setIsLoading(false), 1500);
  };
  return <div className="bg-white p-6 md:p-8 rounded-2xl shadow-xl border border-gray-100 w-full max-w-md mx-auto relative z-10" data-id="element-138">
      <div className="text-center mb-6" data-id="element-139">
        <h3 className="text-xl font-bold text-gray-900" data-id="element-140">Student Login</h3>
        <p className="text-sm text-gray-500 mt-1" data-id="element-141">
          Access your classes and certificates
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-142">
        <div data-id="element-143">
          <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-144">
            Username
          </label>
          <div className="relative" data-id="element-145">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-146">
              <User className="h-5 w-5 text-gray-400" data-id="element-147" />
            </div>
            <input type="text" id="username" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-brand-purple-500 focus:border-brand-purple-500 transition-colors" placeholder="Enter your username" required data-id="element-148" />
          </div>
        </div>

        <div data-id="element-149">
          <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-150">
            Password
          </label>
          <div className="relative" data-id="element-151">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-152">
              <Lock className="h-5 w-5 text-gray-400" data-id="element-153" />
            </div>
            <input type="password" id="password" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-brand-purple-500 focus:border-brand-purple-500 transition-colors" placeholder="••••••••" required data-id="element-154" />
          </div>
        </div>

        <Button type="submit" className="w-full font-semibold" size="lg" isLoading={isLoading} data-id="element-155">
          Log In <ArrowRight className="ml-2 h-4 w-4" data-id="element-156" />
        </Button>
      </form>

      <div className="mt-6 space-y-3 text-center" data-id="element-157">
        <div className="text-sm" data-id="element-158">
          <span className="text-gray-500" data-id="element-159">New student? </span>
          <a href="#" className="font-medium text-brand-purple-700 hover:text-brand-purple-800 hover:underline" data-id="element-160">
            Create an account
          </a>
        </div>
        <div data-id="element-161">
          <a href="#" className="text-sm text-gray-500 hover:text-gray-700 hover:underline" data-id="element-162">
            Forgot your password?
          </a>
        </div>
      </div>
    </div>;
}